export const EMAILJS_CONFIG = {
    SERVICE_ID: 'service_1d0xa7r',
    TEMPLATE_ID: 'template_i5g0xkg',
    USER_ID: '4s9vWr7SALEDKedug',
};

export const CONTACT_EMAIL = 'plwieseler@gmail.com';